import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import {Actions} from '../../../../common/actions';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import HandleFile from './handleFiles';
import {maxSizeEachFileInMegaBytes} from '../../../../common/constants/ftr';
import {convertBase64ToFiles} from '../../../utils';

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginImagePreview);

const maxSizeEachFileInBytes = maxSizeEachFileInMegaBytes * 1000 * 1024;

const UploadFlInventoryFiles = ({
  currentFileType,
  id,
  isModalOpen,
  openModalInventoryFiles,
  rawAttachments,
  saveFlInventoryAttachments,
  clearFlInventoryFiles,
  disabled,
}) => {
  const [currentFiles, setCurrentFiles] = useState([]);

  useEffect(() => {
    return () => clearFlInventoryFiles();
  }, []);
  
  const closeModal = () => {
    openModalInventoryFiles(false);
  };
  
  const processFiles = () => {
    const formData = new FormData();
    currentFiles?.forEach((element) => {
      if (element) {
        const name = element.name;
  
        if (element.size < maxSizeEachFileInBytes) {
          formData.append(currentFileType, element, name);
        }
      }
    });
    return formData;
  };

  const onSaveAttachments = () => {
    const formData = processFiles();
    saveFlInventoryAttachments(
      formData,
      currentFileType,
      id,
    );
    closeModal();
  };

  useEffect(() => {
    const convertedFiles = async() => {
      const currentFilesRaw = await convertBase64ToFiles(rawAttachments[currentFileType]);
      setCurrentFiles(currentFilesRaw);
    };

    convertedFiles();
  }, [rawAttachments, currentFileType]);
  
  return (
    <Modal
      size="small"
      open={isModalOpen}
      className="report-modal"
    >
      <Modal.Header>ARCHIVOS ADJUNTOS</Modal.Header>
      <Modal.Content className="report-content">
        <HandleFile
          id={currentFileType}
          attachment={currentFiles}
          setAttachment={setCurrentFiles}
          disabled={disabled}
        />
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={closeModal}>Cerrar</Button>
        <Button
          disabled={disabled}
          positive onClick={onSaveAttachments}
          className='mini-button-upload-file'
        >
            Guardar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const {
  clearFlInventoryFiles,
  openModalInventoryFiles,
  saveFlInventoryAttachments,
  setClientCurrFiles,
  setInfoCertCurrFiles,
  setOthersCurrFiles,
} = Actions;

const mapStateToProps = (state) => {
  return {
    'isModalOpen': state.manageFlFiles.isModalOpen,
    'currentFileType': state.manageFlFiles.currentFileType,
    'rawAttachments': state.manageFlFiles.rawAttachments,
    'currentLine': state.manageFlFiles.currentLine,
    'disabled': state.manageFlFiles.disabled,
    'id': state.manageFlFiles.id,
  };
};

export default connect(mapStateToProps, {
  clearFlInventoryFiles,
  openModalInventoryFiles,
  saveFlInventoryAttachments,
  setClientCurrFiles,
  setInfoCertCurrFiles,
  setOthersCurrFiles,
})(
  UploadFlInventoryFiles
);
